export const SESSION_EXPIRED_EVENT = 'lorath:session_expired';

let sessionExpiredEmitted = false;

// Nur ein Signal pro laufender App-Instanz: parallele 401-Antworten duerfen
// spaetere Konsumenten nicht mit identischen Session-Events fluten.
export function emitSessionExpiredOnce(): void {
  if (sessionExpiredEmitted || typeof window === 'undefined') return;
  sessionExpiredEmitted = true;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, {
    detail: { code: 'session_expired' },
  }));
}

// Ein neuer Bearer steht fuer eine neue Sitzung; deren spaeterer Ablauf muss
// wieder genau ein eigenes Signal ausloesen koennen.
export function resetSessionExpiredEventDeduplication(): void {
  sessionExpiredEmitted = false;
}

export function onSessionExpired(callback: () => void): () => void {
  if (typeof window === 'undefined') return () => undefined;
  const listener = () => callback();
  window.addEventListener(SESSION_EXPIRED_EVENT, listener);
  return () => window.removeEventListener(SESSION_EXPIRED_EVENT, listener);
}
